import React from 'react';
import AptStartTest from './AptStartSteps';

const Index = () => {
  return (
    <div>
      <AptStartTest />
    </div>
  );
};

export default Index;
